import React from "react";

/**
 * A simple error bar component that displays an error message
 * After header before selections.
 *
 * Exmple usage:
 * <ErrorBar message="An error occurred while fetching data." />
 *
 * use cases:
 * - Display when odds changes and Accept odds changes is not checked
 * - Display when selectionLimit exceeded
 */
interface ErrorBarProps {
  message: string;
}

export const ErrorBar: React.FC<ErrorBarProps> = ({ message }) => (
  <div className="bg-teaser-danger px-3 py-2">
    <p className="text-sm text-teaser-danger-text">{message}</p>
  </div>
);
